import React, { useEffect, useState } from "react";
import { Divider } from "primereact/divider";
import anc from "../../../../Assets/pregnant_anc.png";
import pnc from "../../../../Assets/pregnant_pnc.png";
import child from "../../../../Assets/pregnant_child.png";
import "./AshaProfileViewStyle.scss";
import { useTranslation } from "react-i18next";

const AshaProfileView = ({ profile, status }) => {
  const { t } = useTranslation("AshaProfile");
  const [totActiveCases, setTotalActiveCases] = useState(0);
  const [ancData, setAncData] = useState({
    total: 0,
    Critical: 0,
    Normal: 0,
    highRisk: 0,
  });
  const [pncData, setPncData] = useState({
    total: 0,
    Critical: 0,
    Normal: 0,
    highRisk: 0,
  });
  const [childData, setChildData] = useState({
    total: 0,
    Critical: 0,
    Normal: 0,
    highRisk: 0,
  });
  const [todayAncData, setTodayAncData] = useState({
    total: 0,
    Critical: 0,
    Normal: 0,
    highRisk: 0,
  });
  const [todayPncData, setTodayPncData] = useState({
    total: 0,
    Critical: 0,
    Normal: 0,
    highRisk: 0,
  });
  const [todayChildData, setTodayChildData] = useState({
    total: 0,
    Critical: 0,
    Normal: 0,
    highRisk: 0,
  });

  const fetchCaseImg = (type) => {
    const imgTypes = {
      ANC: anc,
      PNC: pnc,
    };
    return imgTypes[type] || child;
  };
  useEffect(() => {
    if (profile.activecases) {
      const processedData = profile.activecases.reduce(
        (acc, el) => {
          switch (el.type) {
            case "ANC":
              setAncData(el);
              break;
            case "PNC":
              setPncData(el);
              break;
            case "Child":
              setChildData(el);
              break;
              case "TODAYANC":
                setTodayAncData(el);
                break;
              case "TODAYPNC":
                setTodayPncData(el);
                break;
              case "TODAYChild":
                setTodayChildData(el);
                break;
            default:
              console.warn(`Unhandled case type: ${el.type}`); 
              break;
          }
          return {
            totalActiveCases: acc.totalActiveCases + el.total,
          };
        },
        { totalActiveCases: 0 }
      );

      setTotalActiveCases(processedData.totalActiveCases);
    }
  }, [profile.activecases]);
  let ashaId = "";
  if (profile.ashadetails) {
    ashaId = profile.ashadetails.ashaId;
  }
  function safeAccess(obj, props, defaultValue = "") {
    return props.reduce(
      (acc, prop) =>
        acc && acc[prop] !== undefined ? acc[prop] : defaultValue,
      obj
    );
  }

  const joiningDate = safeAccess(profile, ["ashadetails", "joiningDate"]);
  const mobileNumber = safeAccess(profile, ["ashadetails", "mobileNumber"]);
  const age = safeAccess(profile, ["ashadetails", "age"]);
  const address = safeAccess(profile, ["ashadetails", "address"]);
  const adhar = safeAccess(profile, ["ashadetails", "aadhar"]);
  const bankAcc = safeAccess(profile, ["ashadetails", "bankAccountNo"]);
  const anmName = safeAccess(profile, ["ashadetails", "anmName"]);
  const anmId = safeAccess(profile, ["ashadetails", "anmId"]);
  const phcName = safeAccess(profile, ["ashadetails", "phc"]);
  const subCenterName = safeAccess(profile, ["ashadetails", "subCenterName"]);
  const total = safeAccess(profile, ["totalTreatedCases", "total"]);
  const critical = safeAccess(profile, ["totalTreatedCases", "Critical"]);
  const normal = safeAccess(profile, ["totalTreatedCases", "Normal"]);
  const highRisk = safeAccess(profile, ["totalTreatedCases", "highRisk"]);
  console.log("total",total,critical,normal,highRisk);
  return (
    <div>
      <div className="grid justify-content-center">
        <div className="sm:col-12 md:col-4 p-2">
          <div
            className="flex flex-column justify-content-start"
            style={{ color: "#1D2965" }}
          >
            <div className="font-semibold text-sm mb-2">{t("ASHADetails")}</div>
            <div className="font-light text-sm mt-1 mb-1 surface-50 p-1 text-left border-round-sm ">
              {t("ASHAID")}:{ashaId}
            </div>
            <div className="font-light text-sm mt-1 mb-2 surface-50 p-1 text-left border-round-sm ">
              {t("JoiningDate")} :{joiningDate}
            </div>
            <Divider />
          </div>
          <div
            className="flex flex-column justify-content-start"
            style={{ color: "#1D2965" }}
          >
            <div className="font-light text-sm mt-2 mb-1 surface-50 p-1 text-left border-round-sm ">
              {t("MobileNo")} :{mobileNumber}
            </div>
            <div className="font-light text-sm mt-1 mb-1 surface-50 p-1 text-left border-round-sm ">
              {t("Age")} :{age}
            </div>
            <div className="font-light text-sm mt-1 mb-1 surface-50 p-1 text-left border-round-sm ">
              {t("Address")} :{address}
            </div>
            <div className="flex font-light text-sm mt-1 mb-1 surface-50 p-1 text-left border-round-sm ">
              {t("AdharNo")}:<div className="verifiedStyle"> {adhar}</div>
            </div>
            <div className="font-light text-sm mt-1 mb-2 surface-50 p-1 text-left border-round-sm ">
              {t("BankAccNo")} :{bankAcc}
            </div>
            <Divider />
          </div>
          <div className="flex flex-column justify-content-start">
            <div className="font-light text-sm mt-2 mb-1 surface-50 p-1 text-left border-round-sm ">
              {t("ANMName")} :<span className="font-normal">{anmName}</span>
            </div>
            <div className="font-light text-sm mt-1 mb-1 surface-50 p-1 text-left border-round-sm ">
              {t("ANMId")} :{anmId}
            </div>
            <div className="font-light text-sm mt-1 mb-1 surface-50 p-1 text-left border-round-sm ">
              {t("PHC")} :{phcName}
            </div>
            <div className="font-light text-sm mt-1 mb-2 surface-50 p-1 text-left border-round-sm ">
              {t("Subcenter")} :{subCenterName}
            </div>
          </div>
        </div>
        <div className="sm:col-12 md:col-8 asha-case-details p-4 ">
          <div className="grid">
            <div className="md:col-5">
              <div className="flex flex-column justify-content-start border-round-lg border-200 border-2 p-2">
                <div
                  className="font-semibold text-sm mb-2"
                  style={{ color: "#1D2965" }}
                >
                  {t("TotalTreatedCases")}
                </div>
                <div
                  className="font-normal text-xs mb-2"
                  style={{ color: "#1D2965" }}
                >
                  ({t("Today's Count")})
                </div>
                <div className="font-semibold text-xl mt-1 mb-1 surface-50 p-2 h-3rem text-center">
                  {todayAncData.total + todayPncData.total + todayChildData.total}
                </div>
                <div className="mt-3 mb-2 p-3">
                  <div className="grid justify-content-evenly gap-1">
                    <div
                      className="md:col-4 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#E03581" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#E03581" }}
                      >
                        {todayAncData.Critical + todayPncData.Critical + todayChildData.Critical}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#E03581" }}
                      >
                        {t("Critical")}
                      </div>
                    </div>
                    <div
                      className="md:col-4 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#1D2965" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#1D2965" }}
                      >
                        {todayAncData.highRisk + todayPncData.highRisk + todayChildData.highRisk}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#1D2965" }}
                      >
                        {t("HighRisk")}
                      </div>
                    </div>
                    <div
                      className="md:col-4 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#08787E" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#08787E" }}
                      >
                        {todayAncData.Normal + todayPncData.Normal + todayChildData.Normal}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#08787E" }}
                      >
                        {t("Normal")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="md:col-7">
              <div className="flex flex-column justify-content-start p-2">
                <div className="font-semibold text-sm mb-2">
                  {t("TotalActiveCases")} : {totActiveCases}
                </div>
                <div className="m-1">
                  <div className="grid justify-content-evenly gap-1 p-2">
                    <div className="md:col-3 p-1 h-4rem w-4rem">
                      <div>
                        <img
                          src={fetchCaseImg("ANC")}
                          alt="pregnant_anc"
                          width="24px"
                          height="24px"
                        />
                      </div>
                      <div className="font-semibold text-sm ">{t("ANC")}</div>
                      <div className="font-semibold text-sm ml-2">
                        {ancData.total}
                      </div>
                    </div>
                    <div
                      className="md:col-3 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#E03581" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#E03581" }}
                      >
                        {ancData.Critical}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#E03581" }}
                      >
                        {t("Critical")}
                      </div>
                    </div>
                    <div
                      className="md:col-3 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#1D2965" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#1D2965" }}
                      >
                        {ancData.highRisk}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#1D2965" }}
                      >
                        {t("HighRisk")}
                      </div>
                    </div>
                    <div
                      className="md:col-3 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#08787E" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1 ml-2"
                        style={{ color: "#08787E" }}
                      >
                        {ancData.Normal}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#08787E" }}
                      >
                        {t("Normal")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-1">
                  <div className="grid justify-content-evenly gap-1 p-2">
                    <div className="md:col-3 p-1 h-4rem w-4rem">
                      <div>
                        <img
                          src={fetchCaseImg("PNC")}
                          alt="pregnant_pnc"
                          width="24px"
                          height="24px"
                        />
                      </div>
                      <div className="font-semibold text-sm ">{t("PNC")}</div>
                      <div
                        className="font-semibold text-sm "
                        style={{ marginLeft: "0.3rem" }}
                      >
                        {pncData.total}
                      </div>
                    </div>
                    <div
                      className="md:col-3 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#E03581" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#E03581" }}
                      >
                        {pncData.Critical}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#E03581" }}
                      >
                        {t("Critical")}
                      </div>
                    </div>
                    <div
                      className="md:col-3 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#1D2965" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#1D2965" }}
                      >
                        {pncData.highRisk}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#1D2965" }}
                      >
                        {t("HighRisk")}
                      </div>
                    </div>
                    <div
                      className="md:col-3 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#08787E" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#08787E" }}
                      >
                        {pncData.Normal}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#08787E" }}
                      >
                        {t("Normal")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-1">
                  <div className="grid justify-content-evenly gap-1 p-2">
                    <div className="md:col-3 p-1 h-4rem w-4rem">
                      <div style={{ marginLeft: "0.2rem" }}>
                        <img
                          src={fetchCaseImg("Child")}
                          alt="pregnant_child"
                          width="24px"
                          height="24px"
                        />
                      </div>
                      <div className="font-semibold text-sm ">{t("Child")}</div>
                      <div className="font-semibold text-sm ml-2">
                        {childData.total}
                      </div>
                    </div>
                    <div
                      className="md:col-3 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#E03581" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#E03581" }}
                      >
                        {childData.Critical}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#E03581" }}
                      >
                        {t("Critical")}
                      </div>
                    </div>
                    <div
                      className="md:col-3 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#1D2965" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#1D2965" }}
                      >
                        {childData.highRisk}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#1D2965" }}
                      >
                        {t("HighRisk")}
                      </div>
                    </div>
                    <div
                      className="md:col-3 border-2 border-round-lg p-1 h-4rem w-5rem text-center"
                      style={{ borderColor: "#08787E" }}
                    >
                      <div
                        className="font-semibold text-sm mb-1 mt-1"
                        style={{ color: "#08787E" }}
                      >
                        {childData.Normal}
                      </div>
                      <div
                        className="font-semibold text-sm mt-1 mb-1"
                        style={{ color: "#08787E" }}
                      >
                        {t("Normal")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* {!status && (
                // <div className="text-sm  surface-50 p-2 h-2rem text-left text-red-300 border-round-sm mt-2">
                //   Did not treated any patient since 01.08.2023
                // </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AshaProfileView;
